export default import.meta.ROLLDOWN_FILE_URL_sM6agrJ6GRDAt2xqS1b0OA